import React, { useEffect, useState } from "react";
import momentTZ from "moment-timezone";
import styled from "styled-components";
import firebase, { FS } from "../../services/firebase";
import { get } from "lodash";
import { DEFAULT_TIMEZONE } from "../../constants";

// Rendered and compared in the tenant zone: on the browser clock a Brisbane
// tenant viewed from Melbourne could drop today's appointment from the list
// or show it at the wrong hour.
function getCoreplusDateTimeMoment(rawDateTime) {
  return momentTZ(rawDateTime.replace(" ", "")).tz(DEFAULT_TIMEZONE);
}

function getLiveAppointmentParticipantStatusClassName(connected, disconnected) {
  if (disconnected) {
    return "has-background-warning-light";
  }
  if (connected) {
    return "has-background-primary-light";
  }
  return "";
}

const LiveAppointments = () => {
  const [liveAppointments, setLiveAppointments] = useState([]);

  useEffect(() => {
    const unsubscribe = FS.onSnapshot(
      FS.query(FS.collection(firebase.modularFirestore(), "client_appointments"), FS.where("archived", "==", false)),
      (snapshot) => {
        const apts = [];
        snapshot.forEach((doc) => {
          const ca = doc.data();
          if (!ca.appointment) {
            return;
          }

          const aptStartDatetime = getCoreplusDateTimeMoment(ca.appointment.startDateTime);
          if (!aptStartDatetime.isSame(momentTZ().tz(DEFAULT_TIMEZONE), "day")) {
            return;
          }
          apts.push(ca);
        });
        setLiveAppointments(apts);
      }
    );
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <StyledTable className="table is-hoverable is-size-7">
      <thead>
        <tr>
          <th>Appointment</th>
          <th>Specialist</th>
          <th>Patient</th>
          <th>Video Medical Consultation</th>
        </tr>
      </thead>
      <tbody>
        {liveAppointments.map((ca, idx) => {
          const { specialist_connected, specialist_disconnected, patient_connected, patient_disconnected } = get(
            ca,
            "live_appointment",
            {}
          );

          return (
            <tr key={idx}>
              <td>{getCoreplusDateTimeMoment(ca.appointment.startDateTime).format("YYYY-MM-DD HH:mm:ss z")}</td>
              <td
                className={getLiveAppointmentParticipantStatusClassName(specialist_connected, specialist_disconnected)}
              >
                {`${ca.practitioner.firstName} ${ca.practitioner.lastName}`}{" "}
                <span className="tag is-primary is-radiusless">3:06</span>
              </td>
              <td
                className={getLiveAppointmentParticipantStatusClassName(patient_connected, patient_disconnected)}
              >{`${ca.client.firstName} ${ca.client.lastName}`}</td>
              <td>
                <a href="#t">JOIN</a>
              </td>
            </tr>
          );
        })}
      </tbody>
    </StyledTable>
  );
};

const StyledTable = styled.table`
  th:nth-child(1) {
    width: 20%;
  }
  th:nth-child(2) {
    width: 35%;
  }
  th:nth-child(3) {
    width: 35%;
  }
  th:nth-child(4) {
    width: 10%;
  }
`;

export default LiveAppointments;
